<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>IPCR Approval - {{ emp_name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="12" v-if="isSubmitted">
                <v-stepper alt-labels class="elevation-0">
                  <v-stepper-header>
                    <v-stepper-step
                      step="1"
                      class="pa-5"
                      :complete="assessed_by_status == 2 ? true : false"
                      :rules="[() => assessed_by_status != 3]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{ assessed_by }}
                        <small>Assessed By<br /> </small>
                      </div>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="2"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{ final_rating_by }}
                        <small>Final Rating <br /> </small>
                      </div>
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-col>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-spacer></v-spacer>

              <v-col cols="12" class="pt-2 px-4">
                <table v-if="tab != 4" id="ipcrTable">
                  <tr>
                    <td
                      colspan="2"
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Major Final Output(MFO)
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Success Indicators<br />Target + Measure
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Actual Accomplishments
                    </td>
                    <td
                      style="width: 20%"
                      colspan="4"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Rating
                    </td>
                    <td
                      style="width: 20%"
                      rowspan="2"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Remarks
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      E
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Q
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      T
                    </td>
                    <td
                      style="width: 5%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      A
                    </td>
                  </tr>
                  <tbody
                    v-if="
                      ipcrToView && ipcrToView.func_type != 'Support Function'
                    "
                  >
                    <tr>
                      <td
                        colspan="9"
                        class="text-subtitle-1 text-justify font-weight-bold"
                        style="text-indent: 10px"
                      >
                        {{ ipcrToView && ipcrToView.func_type }}
                        ({{ ipcrToView && ipcrToView.prct_display + "%" }})
                      </td>
                    </tr>
                    <!-- cf insruction / sp research-->
                    <tr>
                      <td colspan="9" align="left" class="text-caption pa-2">
                        <b v-if="tab == 1"
                          >{{ getCFIntruction.type }} ({{
                            (data.facultyType == "designated"
                              ? getCFIntruction.prct_display
                              : ipcrToView && ipcrToView.prct_display) + "%"
                          }})</b
                        >
                        <b v-if="tab == 2"
                          >{{ getSPResearch.type }}
                          {{
                            data.facultyType == "designated"
                              ? ""
                              : "(" + getSPResearch.prct_display + "%)"
                          }}</b
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(item, i) in tab == 1
                        ? getCFIntruction.data
                        : tab == 2
                        ? getSPResearch.data
                        : []"
                      :key="item.id"
                    >
                      <td class="text-caption pa-1" align="center">
                        <!-- {{
                          ipcrToView.func_type == "Core Function"
                            ? "CF" + (i + 1)
                            : ipcrToView.func_type == "Strategic Priority"
                            ? "SP" + (i + 1)
                            : null
                        }} -->
                        {{
                          tab == 1
                            ? "CF" + (i + 1)
                            : tab == 2
                            ? "SP" + (i + 1)
                            : null
                        }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.e_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.q_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.t_avg }}
                      </td>
                      <td class="text-caption pa-1" align="center">
                        {{ formatNumberValue(item.a_avg, 2) }}

                        <b v-if="tab == 1">{{ " | " + item.a_avg_prct }}</b
                        ><i v-if="tab == 1">{{
                          " (" + item.prct * 100 + "%)"
                        }}</i>
                      </td>
                      <td class="text-caption">
                        <!-- <div class="d-flex justify-space-between pa-2">
                          <div>
                            {{ item.remarks }}
                          </div>
                          <div>
                            <v-btn
                              v-if="item.remarks == null"
                              class="my-1"
                              x-small
                              block
                              outlined
                              color="#519043"
                              @click="
                                addRemarks(
                                  item,
                                  tab == 1
                                    ? 'CF'
                                    : tab == 2
                                    ? 'SP'
                                    : tab == 3
                                    ? 'SF'
                                    : null
                                )
                              "
                              >Add</v-btn
                            >
                            <v-btn
                              v-if="item.remarks != null"
                              class="my-1"
                              x-small
                              block
                              outlined
                              color="warning"
                              >Update</v-btn
                            >
                          </div>
                        </div> -->
                      </td>
                    </tr>
                    <!-- end of cf insruction /sp research-->
                    <!-- cf designatin\on -->
                    <tr>
                      <td colspan="9" align="left" class="text-caption pa-2">
                        <b v-if="tab == 1 && data.facultyType == 'designated'"
                          >{{ getCFDesignation.type }} ({{
                            getCFDesignation.prct_display + "%"
                          }})</b
                        >
                        <b v-if="tab == 2"
                          >{{ getSPExtension.type }}
                          {{
                            data.facultyType == "designated"
                              ? ""
                              : "(" + getSPExtension.prct_display + "%)"
                          }}</b
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(item, i) in tab == 1 &&
                      data.facultyType == 'designated'
                        ? getCFDesignation.data
                        : tab == 2
                        ? getSPExtension.data
                        : null"
                      :key="item.id"
                    >
                      <td class="text-caption pa-1" align="center">
                        {{
                          tab == 1
                            ? "CF" + (getCFIntruction.data.length + i + 1)
                            : tab == 2
                            ? "SP" + (getSPResearch.data.length + i + 1)
                            : null
                        }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.e_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.q_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.t_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ formatNumberValue(item.a_avg, 2) }}
                      </td>
                      <td class="text-caption" align="center"></td>
                    </tr>
                    <!-- end of cf designation -->
                    <tr>
                      <td colspan="7" align="right" class="text-caption pa-2">
                        Total {{ ipcrToView.func_type }}
                      </td>
                      <td align="center" class="text-caption pa-2">
                        <div
                          class="d-flex justify-space-between"
                          v-if="tab == 1 && data.facultyType == 'designated'"
                        >
                          <div>Instruction</div>
                          <div class="font-weight-bold">
                            {{ getSubTotal.instruction }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between"
                          v-if="tab == 1 && data.facultyType == 'designated'"
                        >
                          <div>Designation</div>
                          <div class="font-weight-bold">
                            {{ getSubTotal.designation }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between"
                          v-if="tab == 1 && data.facultyType != 'designated'"
                        >
                          <div class="font-weight-bold">
                            {{ getSubTotal.instruction_non_designated }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between"
                          v-if="tab == 2 && data.facultyType == 'designated'"
                        >
                          <div class="font-weight-bold">
                            {{ getSubTotal.researchAndExtension }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between"
                          v-if="tab == 2 && data.facultyType != 'designated'"
                        >
                          <div>Research</div>
                          <div class="font-weight-bold">
                            {{ getSubTotal.research }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-space-between"
                          v-if="tab == 2 && data.facultyType != 'designated'"
                        >
                          <div>Extension</div>
                          <div class="font-weight-bold">
                            {{ getSubTotal.extension }}
                          </div>
                        </div>
                      </td>
                      <td class="text-caption"></td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td
                        colspan="9"
                        class="text-subtitle-1 text-justify font-weight-bold"
                        style="text-indent: 10px"
                      >
                        {{ ipcrToView && ipcrToView.func_type }} ({{
                          ipcrToView && ipcrToView.prct_display + "%"
                        }})
                      </td>
                    </tr>

                    <tr
                      v-for="(item, i) in getSFInstOblig.data"
                      :key="item.id + i"
                    >
                      <td
                        v-if="i == 0"
                        :rowspan="getSFInstOblig.data.length"
                        class="text-caption pa-1"
                        align="center"
                      >
                        SF1
                      </td>
                      <td
                        v-if="i == 0"
                        :rowspan="getSFInstOblig.data.length"
                        class="text-caption pa-1"
                        align="left"
                      >
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.e_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.q_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.t_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ formatNumberValue(item.a_avg, 2) }}
                      </td>
                      <td class="text-caption" align="center"></td>
                    </tr>
                    <tr v-for="(item, i) in getProfDev.data" :key="item.id">
                      <td class="text-caption pa-1" align="center">
                        SF {{ i + 2 }}
                      </td>
                      <td
                        v-if="i == 0"
                        :rowspan="getProfDev.data.length"
                        class="text-caption pa-1"
                        align="left"
                      >
                        {{ item.mfo }}
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ item.success_indicator }}
                      </td>
                      <td
                        class="text-caption preserve-whitespace pa-2"
                        align="left"
                      >
                        {{ item.actual_accomplishment }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.e_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.q_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{ item.t_avg }}
                      </td>
                      <td class="text-caption" align="center">
                        {{
                          !isNaN(item.a_avg)
                            ? formatNumberValue(item.a_avg, 2)
                            : ""
                        }}
                      </td>
                      <td class="text-caption" align="center"></td>
                    </tr>
                    <tr>
                      <td colspan="7" align="right" class="text-caption pa-1">
                        Total
                      </td>
                      <td class="text-caption pa-1" align="left">
                        {{ getSubTotal.sfTotal }}
                      </td>

                      <td class="text-caption" align="center"></td>
                    </tr>
                  </tbody>
                </table>
                <table v-else id="categoryTable">
                  <tr>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption pa-1"
                      align="center"
                    >
                      Category
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Total
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Number of MFO's
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      Percentage(%)
                    </td>
                    <td
                      style="width: 20%"
                      class="font-weight-bold text-caption"
                      align="center"
                    >
                      General Average
                    </td>
                  </tr>
                  <tr v-for="(item, i) in category" :key="i">
                    <td
                      align="left"
                      style="text-indent: 10px"
                      class="text-caption pa-1"
                      :colspan="item.cols"
                    >
                      {{ item.type }}
                    </td>
                    <td
                      v-if="item.cols == 1"
                      align="center"
                      class="text-caption"
                    >
                      <div v-if="i == 0" class="pa-2">
                        <div v-if="item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Instruction</i></div>
                            <div>
                              {{
                                formatNumberValue(
                                  item.total_arr.instruction.subT,
                                  2
                                )
                              }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Designation</i></div>
                            <div>
                              {{
                                formatNumberValue(
                                  item.total_arr.designation.subT,
                                  2
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          {{ item.subT ? item.subT : item.total }}
                        </div>
                      </div>
                      <div v-if="i == 1" class="pa-2">
                        <div v-if="!item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Research</i></div>
                            <div>
                              {{
                                formatNumberValue(
                                  item.total_arr.research.subT,
                                  2
                                )
                              }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Extension</i></div>
                            <div>
                              {{
                                formatNumberValue(
                                  item.total_arr.extension.subT,
                                  2
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          {{ item.subT ? item.subT : item.total }}
                        </div>
                      </div>
                      <div v-if="i > 1">
                        {{ item.total }}
                      </div>
                    </td>
                    <td
                      v-if="item.cols == 1"
                      align="center"
                      class="text-caption"
                    >
                      <div v-if="i == 0" class="pa-2">
                        <div v-if="item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Instruction</i></div>
                            <div>
                              {{ item.mfo_cnt_div.instruction }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Designation</i></div>
                            <div>
                              {{ item.mfo_cnt_div.designation }}
                            </div>
                          </div>
                        </div>
                        <div v-else>{{ item.mfo_cnt }}</div>
                      </div>
                      <div v-if="i == 1" class="pa-2">
                        <div v-if="!item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Research</i></div>
                            <div>
                              {{ item.mfo_cnt_div.research }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Extension</i></div>
                            <div>
                              {{ item.mfo_cnt_div.extension }}
                            </div>
                          </div>
                        </div>
                        <div v-else>{{ item.mfo_cnt }}</div>
                      </div>
                      <div v-if="i > 1">
                        {{ item.mfo_cnt }}
                      </div>
                    </td>
                    <td
                      v-if="item.cols == 1"
                      align="center"
                      class="text-caption"
                    >
                      {{ item.percentage }}
                    </td>
                    <td align="center" class="text-caption">
                      <div v-if="i == 0" class="pa-2">
                        <div v-if="item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Instruction</i></div>
                            <div>
                              {{
                                formatNumberValue(
                                  item.total_arr.instruction.subT,
                                  3
                                ) +
                                " * " +
                                item.total_arr.instruction.percent +
                                " = " +
                                formatNumberValue(
                                  item.total_arr.instruction.total,
                                  3
                                )
                              }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Designation</i></div>
                            <div>
                              {{
                                "(" +
                                formatNumberValue(
                                  item.total_arr.designation.subT,
                                  3
                                ) +
                                "/" +
                                item.mfo_cnt_div.designation +
                                ") * " +
                                item.total_arr.designation.percent +
                                " = " +
                                formatNumberValue(
                                  item.total_arr.designation.total,
                                  3
                                )
                              }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Total</i></div>
                            <div>
                              {{ "(" + item.percentage + ") " + item.gen_avg }}
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          {{
                            item.subT +
                            " * " +
                            item.percentage +
                            " = " +
                            item.gen_avg
                          }}
                        </div>
                      </div>
                      <div v-if="i == 1" class="pa-2">
                        <div v-if="!item.isDesignated">
                          <div class="d-flex justify-space-between">
                            <div><i>Research</i></div>
                            <div>
                              {{
                                "(" +
                                item.total_arr.research.subT +
                                "/" +
                                item.mfo_cnt_div.research +
                                ") * " +
                                item.total_arr.research.percent +
                                " = " +
                                formatNumberValue(
                                  item.total_arr.research.total,
                                  2
                                )
                              }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Extension</i></div>
                            <div>
                              {{
                                "(" +
                                item.total_arr.extension.subT +
                                "/" +
                                item.mfo_cnt_div.extension +
                                ") * " +
                                item.total_arr.extension.percent +
                                " = " +
                                formatNumberValue(
                                  item.total_arr.extension.total,
                                  2
                                )
                              }}
                            </div>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div><i>Total</i></div>
                            <div>
                              {{ "(" + item.percentage + ") " + item.gen_avg }}
                            </div>
                          </div>
                        </div>
                        <div v-else>{{ item.gen_avg }}</div>
                      </div>
                      <div v-if="i > 1">{{ item.gen_avg }}</div>

                      <!-- {{ item.gen_avg }} -->
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>

          <v-btn color="red" @click="pendingIpcr()" class="white--text">
            Pending
          </v-btn>

          <v-btn color="#519043" @click="approveIpcr()" class="white--text">
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to <b>{{ approvalAction }}</b> this IPCR?<br />
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelConfirm()"> Close </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmAction()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- remarks dialog -->
    <v-dialog v-model="addRemarksDialog" persistent max-width="600">
      <v-card color="white">
        <v-form ref="RemarksFormref" @submit.prevent>
          <v-card-title dark class="dialog-header pt-2 pb-2 pl-6">
            <span> Add Remarks </span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="addRemarksDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 400px" class="my-4"> </v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="remarksMsg"
                  :rules="[formRules.required]"
                  dense
                  placeholder="Type remarks here..."
                  outlined
                  rows="5"
                  required
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="addRemarksDialog = false">
              Close
            </v-btn>

            <v-btn
              color="green"
              class="white--text"
              :loading="confirmBtnLoading"
              :disabled="confirmBtnLoading"
              @click="savePendingRemarks()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: null,
  },

  computed: {
    getTotal() {
      let total = 0;
      if (this.tab == 1) {
        total = this.category[0].gen_avg;
      }
      if (this.tab == 2) {
        total = this.category[1].gen_avg;
      }
      if (this.tab == 3) {
        total = this.category[2].gen_avg;
      }

      return total;
    },

    getSubTotal() {
      let total;
      if (this.tab == 1) {
        total = {
          instruction: this.formatNumberValue(
            this.category[0].total_arr.instruction.subT,
            2
          ),
          designation: this.category[0].isDesignated
            ? this.formatNumberValue(
                this.category[0].total_arr.designation.subT,
                2
              )
            : null,
          instruction_non_designated: this.formatNumberValue(
            this.category[0].subT,
            2
          ),
        };
      }
      if (this.tab == 2) {
        total = {
          researchAndExtension: this.formatNumberValue(
            this.category[1].subT,
            2
          ),
          research: !this.category[1].isDesignated
            ? this.formatNumberValue(
                this.category[1].total_arr.research.subT,
                2
              )
            : null,
          extension: !this.category[1].isDesignated
            ? this.formatNumberValue(
                this.category[1].total_arr.extension.subT,
                2
              )
            : null,
        };
      }
      if (this.tab == 3) {
        total = {
          sfTotal: this.formatNumberValue(this.category[2].total, 2),
        };
      }

      return total;
    },

    getCFIntruction() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[0].data[0].data;
        type = this.ipcrData[0].data[0].type;
        percentage = this.ipcrData[0].data[0].percentage;
        prct_display = this.ipcrData[0].data[0].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getCFDesignation() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData && this.data.facultyType == "designated") {
        data = this.ipcrData[0].data[1].data;
        type = this.ipcrData[0].data[1].type;
        percentage = this.ipcrData[0].data[1].percentage;
        prct_display = this.ipcrData[0].data[1].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSPResearch() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[1].data[0].data;
        type = this.ipcrData[1].data[0].type;
        percentage = this.ipcrData[1].data[0].percentage;
        prct_display = this.ipcrData[1].data[0].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSPExtension() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[1].data[1].data;
        type = this.ipcrData[1].data[1].type;
        percentage = this.ipcrData[1].data[1].percentage;
        prct_display = this.ipcrData[1].data[1].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSFInstOblig() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[2].data[0];
        // type = this.ipcrData[2].data[0].type;
        // percentage = this.ipcrData[2].data[0].percentage;
        // prct_display = this.ipcrData[2].data[0].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    // getSFInterveneFunc() {
    //   let data = [];
    //   let type = "";
    //   let percentage = null;
    //   let prct_display = null;
    //   if (this.ipcrData) {
    //     data = this.ipcrData[2].data[1];
    //     // type = this.ipcrData[2].data[1].type;
    //     // percentage = this.ipcrData[2].data[1].percentage;
    //     // prct_display = this.ipcrData[2].data[1].prct_display;
    //   }
    //   return {
    //     type,
    //     percentage,
    //     prct_display,
    //     data,
    //   };
    // },
    getProfDev() {
      let data = [];
      let type = "";
      let percentage = null;
      let prct_display = null;
      if (this.ipcrData) {
        data = this.ipcrData[2].data[1];
        // type = this.ipcrData[2].data[2].type;
        // percentage = this.ipcrData[2].data[2].percentage;
        // prct_display = this.ipcrData[2].data[2].prct_display;
      }
      return {
        type,
        percentage,
        prct_display,
        data,
      };
    },
    getSF1Len() {
      let len = 0;

      for (let i = 0; i < this.ipcrToView.data.sf1.data.length; i++) {
        if (this.ipcrToView.data.sf1.data[i].addToSF1Divisor) {
          len++;
        }
      }

      return len;
    },

    getIsPendingByApprovers() {
      return this.assessed_by_status == 3 || this.final_rating_by_status == 3;
    },
    getHasUnsavedRemarks() {
      return this.unsavedRemarksList.length > 0;
    },
  },

  data() {
    return {
      category: [],
      remarksData: [],
      remarksMsg: null,
      addRemarksDialog: false,
      approvalAction: null,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      confirmBtnLoading: false,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
        { id: 4, name: "Category" },
      ],
      ipcrData: null,
      ipcrToView: null,
      id: null,
      isSubmitted: null,
      dataItem: [],
      isButtonLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      headers: [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
      support_headers: [
        {
          text: "Type",
          value: "type",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "center",
          width: 250,
          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
      unsavedRemarksList: [],
      emp_name: "Juan Dela Cruz",
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        console.log("Faculty IPCR", data);
        this.emp_name = data.name;
        this.id = data.id;
        this.approvalType = data.approvalType;
        this.assessed_by_status = data.assesed_by_status;
        this.final_rating_by_status = data.final_rating_by_status;
        this.isSubmitted = data.isSubmitted;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    // this.eventHub.$on("closeIPCRFunctionDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closePerformanceEvaluationDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeMPORDialog", () => {
    //   this.initialize();
    // });
    // this.eventHub.$on("closeUpdateSupportFunctionDialog", () => {
    //   this.initialize();
    // });
  },

  beforeDestroy() {
    // this.eventHub.$off("closeIPCRFunctionDialog");
    // this.eventHub.$off("closePerformanceEvaluationDialog");
    // this.eventHub.$off("closeMPORDialog");
    // this.eventHub.$off("closeUpdateSupportFunctionDialog");
  },

  methods: {
    initialize() {
      this.loadRemarks(this.id);
      this.loading = true;
      this.axiosCall("/ipcr/getFacultyIPCR/" + this.id, "GET").then((res) => {
        if (res) {
          console.log("IPCR DATAasdasd", res.data);
          this.ipcrData = res.data.data;
          this.category = res.data.category;
          // console.log("ipcrtoview", res.data.data[this.tab - 1]);
          if (this.tab != 4) {
            this.ipcrToView = res.data.data[this.tab - 1];
          }

          this.loading = false;
        }
      });
      this.axiosCall(
        "/ipcr/getIPCRApproverNames/" + this.id + "/IPCR",
        "GET"
      ).then((res) => {
        if (res) {
          // console.log("signatorues", res.data);
          this.assessed_by = this.toTitleCase(res.data.assessed_by_name);
          // this.assessed_by_status = res.data.assesed_by_status;
          this.final_rating_by = this.toTitleCase(
            res.data.final_rating_by_name
          );
          // this.final_rating_by_status = res.data.final_rating_by_status;
        }
      });
    },

    approveIpcr() {
      this.approvalAction = "APPROVE";
      this.confirmDialog = true;
    },
    pendingIpcr() {
      this.approvalAction = "PENDING";
      this.confirmDialog = true;
    },

    submitIPCR() {
      this.confirmSubmitDialog = true;
    },

    cancelConfirm() {
      this.approvalAction = "";
      this.confirmDialog = false;
    },

    confirmAction() {
      this.isButtonLoading = false;
      this.confirmBtnLoading = false;
      if (this.approvalAction == "PENDING") {
        this.confirmDialog = false;
        this.remarksMsg = null;
        this.addRemarksDialog = true;
      } else {
        this.approve();
      }
    },

    approve() {
      let data = {
        approvalType: this.approvalType,
      };
      this.isButtonLoading = true;
      console.log(data);
      this.axiosCall("/ipcr/approveIPCR/" + this.id, "PATCH", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.isButtonLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      );
    },

    savePendingRemarks() {
      if (this.$refs.RemarksFormref.validate()) {
        let data = {
          approvalType: this.approvalType,
          remarks: this.remarksMsg,
        };
        this.confirmBtnLoading = true;
        this.axiosCall("/ipcr/pendingIPCR/" + this.id, "PATCH", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.confirmBtnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR", "GET").then((res) => {
          if (res.data) {
            // console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      this.eventHub.$emit("closeViewFacultyIPCRApprovalDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmDialog = false;
      this.addRemarksDialog = false;
      this.dialog = false;
    },
    edit(item) {
      if (this.tab != 3) {
        this.ipcrData = item;
        this.action = "Update";
      } else {
        this.ipcrSupData = item;
        this.action = "Update";
      }
    },

    computeGeneralAve(data, percentage) {
      let avg = 0;
      if (percentage != 0) {
        if (data.data.length) {
          avg = ((data.total / data.data.length) * percentage).toFixed(2);
        } else {
          avg = (data.total * percentage).toFixed(2);
        }
        return avg;
      } else {
        return 0.0;
      }
    },

    getOverAllrating() {
      let total = 0;
      for (let i = 0; i < this.ipcrData.length; i++) {
        let d = this.computeGeneralAve(
          this.ipcrData[i],
          this.ipcrData[i].func_type != "Support Function"
            ? this.ipcrData[i].func_type == "Core Function"
              ? this.ipcrData[1].data.length > 0
                ? 0.6
                : 0.9
              : this.ipcrData[1].data.length > 0
              ? 0.3
              : 0
            : 0.1
        );
        total += parseFloat(d);
      }
      return total.toFixed(2);
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    printIPCR() {
      console.log(this.data);
      let url;
      if (this.data.isFaculty == 0) {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/generateIPCRForm/IPCR/" +
          this.data.id;
      } else {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/facultyIPCR/IPCR/" +
          this.data.id;
      }

      let token = localStorage.getItem("token");
      this.isLoading = true;
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } }) // FETCH BLOB FROM IT
        .then((response) => response.blob())
        .then((blob) => {
          // RETRIEVE THE BLOB AND CREATE LOCAL URL
          var _url = window.URL.createObjectURL(blob);

          // window.open(_url, "_blank").focus();
          tab.location = _url;
          tab.focus();
          this.isLoading = false; // window.open + focus
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
#ipcrTable,
#categoryTable {
  width: 100%;
  border-collapse: collapse;
}
#ipcrTable td,
#ipcrTable th,
#categoryTable td,
#categoryTable th {
  border: 1px solid grey;
}
.preserve-whitespace {
  white-space: pre-line;
  word-wrap: break-word;
}
</style>
